module.exports = "<div class=\"msg-row\" *ngIf=\"message.content\">\n    <div class=\"text\">\n        {{ message.content }}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/childs/message/message.component.html
// module id = 557
// module chunks = 0